import { render, staticRenderFns } from "./PaidUnpaidData.vue?vue&type=template&id=16ef2cf1"
import script from "./PaidUnpaidData.vue?vue&type=script&lang=js"
export * from "./PaidUnpaidData.vue?vue&type=script&lang=js"
import style0 from "./PaidUnpaidData.vue?vue&type=style&index=0&id=16ef2cf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports